import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgDuimpje = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      d="M31.52 16.5h-5.27a.74.74 0 0 1-.72-.9l.87-3.9A3.45 3.45 0 0 0 23 7.5a.87.87 0 0 0-.85.68l-1.6 7.18a4 4 0 0 1-1.08 2 4 4 0 0 1-2.83 1.17H14v12h2.87a3.42 3.42 0 0 1 2.42 1c.639.64 1.506 1 2.41 1H30a2.67 2.67 0 0 0 2.65-2.34L34 19.29a2.48 2.48 0 0 0-2.48-2.79"
    />
    <path
      fill="#F170B8"
      d="M14 17.5H6v14h8z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M14.5 19H12v-1h3.5v9.5h-1zM33.124 16.69c.075.262.105.559.063.918a2.2 2.2 0 0 1-.282.884c-.13.225-.288.395-.409.526l-.008.01c-.13.14-.218.238-.289.36a1.2 1.2 0 0 0-.152.49c-.052.432.06.64.223.939.188.347.425.784.337 1.532-.043.36-.143.64-.281.877-.13.222-.286.39-.405.52l-.01.01a2 2 0 0 0-.288.358 1.3 1.3 0 0 0-.157.498c-.03.235-.009.396.027.521.039.135.099.25.188.413l.008.015c.083.153.192.353.263.598.077.263.107.559.065.92a2.2 2.2 0 0 1-.28.88c-.131.226-.288.396-.41.527l-.006.007a2 2 0 0 0-.289.358 1.2 1.2 0 0 0-.156.492l-.992-.126c.046-.36.148-.64.287-.875.13-.22.285-.386.403-.514l.013-.014a2 2 0 0 0 .284-.356c.066-.113.125-.263.152-.496a1.3 1.3 0 0 0-.03-.523c-.04-.135-.102-.25-.191-.416l-.006-.01c-.084-.155-.193-.356-.264-.605a2.3 2.3 0 0 1-.058-.92c.046-.362.148-.643.287-.88.13-.223.286-.392.406-.52l.01-.011a2 2 0 0 0 .285-.356 1.2 1.2 0 0 0 .151-.49c.052-.431-.06-.64-.222-.938h-.001c-.188-.347-.425-.784-.337-1.532.043-.36.144-.642.283-.879.13-.221.285-.39.405-.52l.011-.012c.129-.14.217-.238.288-.36a1.2 1.2 0 0 0 .154-.498 1.3 1.3 0 0 0-.031-.526c-.04-.137-.1-.254-.188-.418l-.002-.002c-.185-.346-.418-.78-.33-1.525l.994.118c-.052.432.059.638.218.935l.007.012c.083.155.191.357.262.604"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgDuimpje);

export default ForwardRef;
